export { default } from './CarTag';
